import type { UserTransformed } from 'src/types/user';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const STORE_NAME = 'User';

export type UserStoreState = {
  isUserChecked: boolean;
  setIsUserChecked: (isUserChecked: boolean) => void;
  user: UserTransformed | null;
  setUser: (user: UserTransformed | null) => void;
};

const initialState = {
  isUserChecked: false,
  user: null,
};

export const useUserStore = create<UserStoreState>()(
  devtools(
    (set) => ({
      ...initialState,
      setIsUserChecked: (isUserChecked) => set(() => ({ isUserChecked })),
      setUser: (user) => set(() => ({ user })),
    }),
    { name: STORE_NAME },
  ),
);
